export enum ConnectionStatusState {
  NONE,
  CONNECTED,
  DISCONNECTED,
  ERROR,
  RECONNECTING,
  RELOAD,
}
